module.exports = __webpack_public_path__ + "img/edge-chromium.bc47546e.svg";